<template>
  <f7-page :page-content="false" @page:beforein="revisarPermisosDeLaRuta">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('empleados.empleados')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="Empleado"
        :tableCode="'EMPLEADO'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :shownFields="['securityUserId']"
        :massiveActions="true"
        :controlsWidth="130"
        :searchOnInit="true"
      >
        <template v-slot:tableLinks>
          <div class="nuevo_empleado"><a class="link" href="/empleados/new/">{{$t('empleados.nuevo')}}</a></div>
        </template>
        <template v-slot:optionsColumn="{item, rlist}">
          <f7-link icon-f7="eye" color="green" :href="`/empleados/view/${item.id}/`" v-tooltip="'Ver'"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/empleados/edit/${item.id}/`" v-tooltip="'Editar'"></f7-link>
          <f7-link v-if="item.securityUserId" icon-f7="lock" color="orange" @click="resetPass(item.securityUserId)" v-tooltip="'Resetear contraseña'"></f7-link>
          <f7-link v-if="puedeBorrar(item)" icon-f7="trash" color="red" @click="rlist.deleteItem(item.id)" v-tooltip="'Borrar'"></f7-link>
          <!-- [#932] Borrar a quien tiene usuario de aplicación le quita el acceso a la ERP: solo
               ADMIN. Se ve apagado y, al pulsarlo, dice por qué y quién lo hace (§9). -->
          <f7-link v-else icon-f7="trash" color="gray" @click="explicarBorrar" v-tooltip="$t('empleados.acceso.soloAdminEliminar')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .nuevo_empleado {
    text-align: center;
    border-radius: 5px;
    margin: 1px 16px;
    padding: 4px;
  }
</style>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import Empleado from "./../../js/db/Empleado.js";
import Usuario from "./../../js/db/Usuario.js";
import permisosDeLaRuta from "./../../js/utils/permisosDeLaRuta.js";
import PermisosEmpleados from "./permisos.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
export default {
  components: {
    rDynamicList
  },
  // [#932] Si puede quitar el acceso a la ERP borrando la ficha. La ruta lleva `keepAlive`, así que
  // el `prop` solo vale para la primera pintura: se vuelve a preguntar al entrar, o tras cambiar de
  // cuenta seguiría decidiendo con el permiso de la anterior (ver `permisosDeLaRuta`).
  mixins: [permisosDeLaRuta({ puedeCambiarAcceso: PermisosEmpleados.cambiarAcceso })],
  data() {
    return {
      Empleado,
      Usuario
    };
  },
  computed: {},
  methods: {
    // La misma regla que la API (`PermisosFichaEmpleado.exigirBaja`): lo que decide es si la ficha
    // tiene usuario de aplicación, que es lo que el borrado se lleva por delante.
    puedeBorrar: function(item) {
      return this.puedeCambiarAccesoAhora || !item.securityUserId;
    },
    explicarBorrar: function() {
      this.$f7.dialog.alert(this.$t("empleados.acceso.soloAdminEliminar"),
        this.$t("empleados.acceso.tituloEliminar"));
    },
    resetPass: function(itemId) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        "¿Seguro que desea resetear la contraseña del usuario seleccionado?",
        "Resetear Contraseña",
        function() {
          // #663 · La espera de la sesión: si la sesión cambia en vuelo o se sale de la pantalla, se suelta sola y solo la suya.
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Usuario.resetPass({itemId: itemId})
            .then(function(res) {
              espera.cerrar();
              app.toast
                .create({
                  text: 'Contraseña Reseteada',
                  position: "center",
                  closeTimeout: 2000
                })
                .open();
            })
            .catch(function(error) {
              espera.cerrar();
              app.dialog.alert(error.error.message);
            });
        }
      );
    }
  }
};
</script>
